<div class="version">
  v{{ version }}
</div>
